// User roles constants - separated from database to avoid client-side imports
export const ROLES = {
  ROOT_ADMIN: 'RootAdmin',
  SITE_ADMIN: 'SiteAdmin',
  NEWS_EDITOR: 'NewsEditor', 
  SERVER_ADMIN: 'ServerAdmin',
  COMMITTEE_EDITOR: 'CommitteeEditor',
  DOCS_MAINTAINER: 'DocsMaintainer',
  READ_ONLY_STAFF: 'ReadOnlyStaff',
  AUTHENTICATED_USER: 'AuthenticatedUser',
} as const

export type Role = typeof ROLES[keyof typeof ROLES]

// Helper function to check if user has a specific role
export function hasRole(permissions: any, role: Role): boolean {
  if (!permissions) return false
  return permissions.roles?.includes(role) || false
}

// Countries with flags for server locations
export const COUNTRIES = [
  { code: 'US', name: 'United States', flag: '🇺🇸' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪' },
  { code: 'NO', name: 'Norway', flag: '🇳🇴' },
  { code: 'FI', name: 'Finland', flag: '🇫🇮' },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦' },
  { code: 'RU', name: 'Russia', flag: '🇷🇺' },
  { code: 'IN', name: 'India', flag: '🇮🇳' },
  { code: 'CN', name: 'China', flag: '🇨🇳' },
  { code: 'RO', name: 'Romania', flag: '🇷🇴' },
  { code: 'IX', name: 'Global/Anycast', flag: '🌍' },
] as const